import { render } from "./modalView.vue?vue&type=template&id=012f3b3e"
import script from "./modalView.vue?vue&type=script&lang=js"
export * from "./modalView.vue?vue&type=script&lang=js"

import "./modalView.vue?vue&type=style&index=0&id=012f3b3e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__